import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import api from './utils/api';
import assetsapi from './utils/assetsapi';
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
// import locale from "../utils/locale"
Vue.use(ElementUI);

Vue.prototype.$api = api;
Vue.prototype.$assetsapi = assetsapi;
// Vue.prototype.get_string = 
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
